import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Loader from '../../../../_common/Loader/Loader';
import classes from '../../dashboard.module.scss';
import Api from '../../../../../api/api';

const ADHERENCE_BUCKETS = [
  {
    key: 'onTrack',
    label: '90–100%',
    legendLabel: 'On track',
    bottomLabel: 'PDC ≥ 90% - on track',
    color: '#22C55E',
  },
  {
    key: 'atRisk',
    label: '80–89%',
    legendLabel: 'At risk',
    bottomLabel: 'PDC 80-89% - at risk',
    color: '#F97316',
  },
  {
    key: 'intervention',
    label: '< 80%',
    legendLabel: 'Intervention needed',
    bottomLabel: 'PDC < 80% - Intervention needed',
    color: '#EF4444',
  },
];

const buildChartOptions = () => ({
  chart: { type: 'bar', toolbar: { show: false }, fontFamily: 'inherit' },
  plotOptions: {
    bar: { columnWidth: '55%', distributed: true, borderRadius: 4 },
  },
  colors: ADHERENCE_BUCKETS.map((b) => b.color),
  dataLabels: { enabled: false },
  legend: { show: false },
  xaxis: {
    categories: ADHERENCE_BUCKETS.map((b) => b.label),
    axisBorder: { show: false },
    axisTicks: { show: false },
    labels: { style: { colors: '#9CA3AF', fontSize: '12px' } },
  },
  yaxis: {
    max: 100,
    tickAmount: 4,
    labels: {
      formatter: (v) => `${v}%`,
      style: { colors: '#9CA3AF', fontSize: '12px' },
    },
  },
  grid: { borderColor: '#F3F4F6', strokeDashArray: 4 },
  tooltip: {
    y: {
      title: { formatter: (_, { dataPointIndex }) => `${ADHERENCE_BUCKETS[dataPointIndex].legendLabel}:` },
      formatter: (v) => `${v}%`,
    },
  },
});

const AdherenceChart = ({ requestData }) => {
  const [adherenceData, setAdherenceData] = useState(null);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getAdherenceChart(requestData);

        setAdherenceData(data);
        loadingToggle(false);
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [requestData]);

  const dist = adherenceData?.distribution ?? {};

  const series = [{ data: ADHERENCE_BUCKETS.map((b) => dist[b.key]?.percent ?? 0) }];

  const legendValues = ADHERENCE_BUCKETS.map((b) => ({
    pct: dist[b.key]?.percent ?? 0,
    pts: dist[b.key]?.pts ?? 0,
  }));

  const isEmpty = series[0].data.every((v) => v === 0);

  return (
    <div className={classes.chart_kpi_wrapper}>
      <p style={{ margin: '16px 0 0 16px', fontWeight: 600, fontSize: 14 }}>Adherence distribution</p>

      {loading
        ? <Loader className={classes.chart_kpi_wrapper_loader} />

        : isEmpty
          ? <div className={classes.chart_is_empty}>No data to display</div>

          : (
            <>
              <Chart
                type="bar"
                height={250}
                series={series}
                options={buildChartOptions()}
              />

              <div style={{ padding: '0 16px 16px' }}>
                {ADHERENCE_BUCKETS.map((bucket, i) => (
                  <div
                    key={bucket.key}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontSize: 13,
                      marginTop: 4,
                      color: '#374151',
                    }}
                  >
                    <span>{bucket.bottomLabel}</span>

                    <span style={{ color: bucket.color, fontWeight: 600 }}>
                      {`${legendValues[i].pct}% · ${legendValues[i].pts} pts`}
                    </span>
                  </div>
                ))}
              </div>
            </>
          )}
    </div>
  );
};

export default AdherenceChart;
